export const splitPhone = (phoneWithNationalCode?: string | null): [ string | null, string | null ] => {
  if (null == phoneWithNationalCode || '' === phoneWithNationalCode) {
    return [ null, null ];
  }

  const phoneArray = phoneWithNationalCode.split(' ');

  const phoneNationalCode = phoneArray[0].includes('+') ? phoneArray[0].trim() : null;

  if (null != phoneNationalCode) {
    phoneArray.shift();
  }

  const phone = phoneArray.join(' ').trim();

  return [ phoneNationalCode, phone ];
};
